import { Grid } from "@mui/material";
import React, { useEffect, useContext, useState } from "react";
import PaymentWidget from "./PaymentWidget";
import AttendenceChart from "./AttendenceChart";
import Notification from "./Notification";
import Overdue from "./Overdue";
import { AppContext } from "../../App";
import { API, actions, endpoints } from "../../api/api";
import moment from "moment";

const Home = () => {
  const { branch, setLoader } = useContext(AppContext);
  const [invs, setInvs] = useState([]);

  useEffect(() => {
    setLoader(true);
    if (branch.id) {
      API(endpoints.Invoice + actions.GetAllByBranch).getById(
        branch.id,
        (res) => {
          res.status === 200 &&
            setInvs([
              ...res.result.filter(
                (j) =>
                  moment(j.addDate, "MM/DD/YYYY").format("MM/YYYY") ===
                  moment().format("MM/YYYY")
              ),
            ]);
          setLoader(false);
        }
      );
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branch]);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={7}>
        <PaymentWidget invs={invs} />
      </Grid>
      <Grid item xs={12} md={5}>
        <AttendenceChart />
      </Grid>
      <Grid item xs={12} md={6}>
        <Notification />
      </Grid>
      <Grid item xs={12} md={6}>
        <Overdue invs={invs} />
      </Grid>
    </Grid>
  );
};

export default Home;
